var _rect, _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _circle, _circle2, _path3, _path4, _path5, _path6, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatientFallback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    rx: 80,
    fill: "#E7F1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 62L54 28L73 56L42 62Z",
    fill: "#7DA7D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118 62L106 28L87 56L118 62Z",
    fill: "#7DA7D9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 88,
    rx: 43,
    ry: 38,
    fill: "#8EB7E8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 104,
    rx: 24,
    ry: 19,
    fill: "#F7FBFF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58,
    cy: 73,
    rx: 9,
    ry: 12,
    fill: "#6F98C8"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 102,
    cy: 73,
    rx: 9,
    ry: 12,
    fill: "#6F98C8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 87,
    r: 4,
    fill: "#20324A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 87,
    r: 4,
    fill: "#20324A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 97C84.4183 97 88 93.4183 88 89C88 84.5817 84.4183 81 80 81C75.5817 81 72 84.5817 72 89C72 93.4183 75.5817 97 80 97Z",
    fill: "#20324A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80 97V104",
    stroke: "#20324A",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80 104C76.5 108.667 73.1667 111 70 111",
    stroke: "#20324A",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80 104C83.5 108.667 86.8333 111 90 111",
    stroke: "#20324A",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 118,
    r: 5,
    fill: "#B7D2F2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 118,
    r: 5,
    fill: "#B7D2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientFallback);
export default __webpack_public_path__ + "static/media/patient-fallback.b339b444b4e803344421f317bee8d68f.svg";
export { ForwardRef as ReactComponent };